export const configHookForm = {
  submitDelay: 1500
};
